"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Generic container to accommodate data required any combo-box option: the key, value and optionally the grouping
 * attributes.
 * @see MultilingualString
 */
var ComboboxOption = /** @class */ (function () {
    /**
     * Constructs the option with provided properties.
     * @param {!T1} value - The identifying value of the option.
     * @param {!T2} name - The display value (human readable).
     * @param {string} [group=null] - Options with identical value should be visually grouped.
     */
    function ComboboxOption(value, name, group) {
        if (group === void 0) { group = null; }
        this.value = value;
        this.name = name;
        this.group = group;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(name);
    }
    ;
    return ComboboxOption;
}());
exports.ComboboxOption = ComboboxOption;
//# sourceMappingURL=combobox-option.js.map